import React from 'react';
import { Modal } from 'antd';
export const LCModal = (props) => (
	<Modal centered {...props}>
		{props.modalContent}
	</Modal>
);
